function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
class SectionId {
  static #e = "__";
  static parseId(e) {
    return e.split(SectionId.#e)[0];
  }
  static parseSectionName(e) {
    return e.split(SectionId.#e)[1];
  }
  static getIdForSection(e, t) {
    return `${e}${SectionId.#e}${t}`;
  }
}
class HTMLUpdateUtility {
  static viewTransition(e, t, s = [], i = []) {
    s?.forEach((e) => e(t));
    const n = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(n, t.outerHTML);
    const r = n.firstChild,
      o = Date.now();
    (e.querySelectorAll("[id], [form]").forEach((e) => {
      (e.id && (e.id = `${e.id}-${o}`),
        e.form && e.setAttribute("form", `${e.form.getAttribute("id")}-${o}`));
    }),
      e.parentNode.insertBefore(r, e),
      (e.style.display = "none"),
      i?.forEach((e) => e(r)),
      setTimeout(() => e.remove(), 500));
  }
  static setInnerHTML(e, t) {
    ((e.innerHTML = t),
      e.querySelectorAll("script").forEach((e) => {
        const t = document.createElement("script");
        (Array.from(e.attributes).forEach((e) => {
          t.setAttribute(e.name, e.value);
        }),
          t.appendChild(document.createTextNode(e.innerHTML)),
          e.parentNode.replaceChild(t, e));
      }));
  }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  (e.setAttribute("role", "button"),
    e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
    e.nextElementSibling.getAttribute("id") &&
      e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open"),
      );
    }),
    e.closest("header-drawer, menu-drawer") ||
      e.parentElement.addEventListener("keyup", onKeyUpEscape));
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var s = getFocusableElements(e),
    i = s[0],
    n = s[s.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== n && t.target !== i) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== n || t.shiftKey || (t.preventDefault(), i.focus()),
        (t.target !== e && t.target !== i) || !t.shiftKey || (t.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus(),
    "INPUT" === t.tagName &&
      ["search", "text", "email", "url"].includes(t.type) &&
      t.value &&
      t.setSelectionRange(0, t.value.length));
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const e = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let t = null,
    s = null;
  (window.addEventListener("keydown", (t) => {
    e.includes(t.code.toUpperCase()) && (s = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      s = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (t && t.classList.remove("focused"),
          s || ((t = document.activeElement), t.classList.add("focused")));
      },
      !0,
    ));
}
function pauseAllMedia() {
  (document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    }));
}
function removeTrapFocus(e = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus());
}
function onKeyUpEscape(e) {
  if ("ESCAPE" !== e.code.toUpperCase()) return;
  const t = e.target.closest("details[open]");
  if (!t) return;
  const s = t.querySelector("summary");
  (t.removeAttribute("open"), s.setAttribute("aria-expanded", !1), s.focus());
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this)),
      ));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this),
      )));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(e) {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = this.input.value;
    ("plus" === e.target.name
      ? parseInt(this.input.dataset.min) > parseInt(this.input.step) && 0 == this.input.value
        ? (this.input.value = this.input.dataset.min)
        : this.input.stepUp()
      : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent),
      this.input.dataset.min === t &&
        "minus" === e.target.name &&
        (this.input.value = parseInt(this.input.min)));
  }
  validateQtyRules() {
    const e = parseInt(this.input.value);
    if (this.input.min) {
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        parseInt(e) <= parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const t = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", e >= t);
    }
  }
}
function debounce(e, t) {
  let s;
  return (...i) => {
    (clearTimeout(s), (s = setTimeout(() => e.apply(this, i), t)));
  };
}
function throttle(e, t) {
  let s = 0;
  return function (...i) {
    const n = new Date().getTime();
    if (!(n - s < t)) return ((s = n), e(...i));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
(customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var s = 0, i = e.options.length; s < i; s++) {
      var n = e.options[s];
      if (t == n.value || t == n.innerHTML) return ((e.selectedIndex = s), s);
    }
  }),
  (Shopify.addListener = function (e, t, s) {
    e.addEventListener ? e.addEventListener(t, s, !1) : e.attachEvent("on" + t, s);
  }),
  (Shopify.postLink = function (e, t) {
    var s = (t = t || {}).method || "post",
      i = t.parameters || {},
      n = document.createElement("form");
    for (var r in (n.setAttribute("method", s), n.setAttribute("action", e), i)) {
      var o = document.createElement("input");
      (o.setAttribute("type", "hidden"),
        o.setAttribute("name", r),
        o.setAttribute("value", i[r]),
        n.appendChild(o));
    }
    (document.body.appendChild(n), n.submit(), document.body.removeChild(n));
  }),
  (Shopify.CountryProvinceSelector = function (e, t, s) {
    ((this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(s.hideElement || t)),
      Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler());
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces",
        ),
        s = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), s && 0 == s.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var i = 0; i < s.length; i++) {
          var n;
          (((n = document.createElement("option")).value = s[i][0]),
            (n.innerHTML = s[i][1]),
            this.provinceEl.appendChild(n));
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild;) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var s = 0;
      for (t.length; s < t.length; s++) {
        var i = document.createElement("option");
        ((i.value = t[s]), (i.innerHTML = t[s]), e.appendChild(i));
      }
    },
  }));
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll(
        "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
      ).forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this))));
  }
  onKeyUp(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("details[open]");
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    const t = e.currentTarget,
      s = t.parentNode,
      i = s.closest(".has-submenu"),
      n = s.hasAttribute("open"),
      r = window.matchMedia("(prefers-reduced-motion: reduce)");
    function o() {
      (trapFocus(t.nextElementSibling, s.querySelector("button")),
        t.nextElementSibling.removeEventListener("transitionend", o));
    }
    s === this.mainDetailsToggle
      ? (n && e.preventDefault(),
        n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t),
        window.matchMedia("(max-width: 990px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`,
          ))
      : setTimeout(() => {
          (s.classList.add("menu-opening"),
            t.setAttribute("aria-expanded", !0),
            i && i.classList.add("submenu-open"),
            !r || r.matches ? o() : t.nextElementSibling.addEventListener("transitionend", o));
        }, 100);
  }
  openMenuDrawer(e) {
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`));
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
        (e.removeAttribute("open"), e.classList.remove("menu-opening"));
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
        e.classList.remove("submenu-open");
      }),
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle),
      e instanceof KeyboardEvent && t?.setAttribute("aria-expanded", !1));
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    const t = e.currentTarget.closest("details");
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    const t = e.closest(".submenu-open");
    (t && t.classList.remove("submenu-open"),
      e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("summary")),
      this.closeAnimation(e));
  }
  closeAnimation(e) {
    let t;
    const s = (i) => {
      void 0 === t && (t = i);
      i - t < 400
        ? window.requestAnimationFrame(s)
        : (e.removeAttribute("open"),
          e.closest("details[open]") &&
            trapFocus(e.closest("details[open]"), e.querySelector("summary")));
    };
    window.requestAnimationFrame(s);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  headerTransparent(e) {
    const t = document.querySelector("sticky-header"),
      s = document.querySelector(".dbtfy-header");
    if (!t || !s) return;
    if (s.classList.contains("scrolled-past-header")) return;
    const i = t,
      n = i.classList,
      r = () => {
        Array.from(n).forEach((e) => {
          (e.startsWith("dbtfy-color-") || e.startsWith("color-")) && n.remove(e);
        });
      },
      o = document.querySelector("header");
    "open" === e
      ? (t.classList.remove("dbtfy-header--transparent"),
        s.classList.remove("header--transparent"),
        o.classList.remove("header--transparent"),
        r(),
        n.add(`dbtfy-color-${i.dataset.colorScheme}`, `color-${i.dataset.customColorScheme}`))
      : ((!0 === Debutify.widgets.header?.header_transparent &&
          document.body.classList.contains("template-index")) ||
          (Debutify.widgets.header?.collection_header_transparent &&
            document.body.classList.contains("template-collection"))) &&
        (t.classList.add("dbtfy-header--transparent"),
        s.classList.add("header--transparent"),
        o.classList.add("header--transparent"),
        r(),
        n.add(
          `dbtfy-color-${i.dataset.transparentHeaderColorScheme}`,
          `color-${i.dataset.customTransparentHeaderColorScheme}`,
        ));
  }
  openMenuDrawer(e) {
    ((this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      e.setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`),
      (document.body.classList.contains("template-index") ||
        document.body.classList.contains("template-collection")) &&
        this.headerTransparent("open"));
  }
  closeMenuDrawer(e, t) {
    t &&
      (super.closeMenuDrawer(e, t),
      this.header.classList.remove("menu-open"),
      window.removeEventListener("resize", this.onResize),
      (document.body.classList.contains("template-index") ||
        document.body.classList.contains("template-collection")) &&
        this.headerTransparent("close"));
  }
  onResize = () => {
    (this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      ),
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`));
  };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    (super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
      this.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (e) => {
            "mouse" !== e.pointerType ||
              e.target.closest("deferred-media, product-model") ||
              this.classList.contains("product-media-modal") ||
              this.hide();
          })
        : this.addEventListener("click", (e) => {
            e.target === this && this.hide();
          }));
  }
  connectedCallback() {
    this.moved ||
      ((this.moved = !0),
      (this.dataset.section = this.closest(".shopify-section")?.id.replace("shopify-section-", "")),
      document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    const t = this.querySelector(".template-popup");
    (document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class BulkModal extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new IntersectionObserver(
      ((e, t) => {
        if (e[0].isIntersecting && (t.unobserve(this), "" === this.innerHTML.trim())) {
          const e = this.dataset.url.split("?")[0];
          fetch(`${e}?section_id=bulk-quick-order-list`)
            .then((e) => e.text())
            .then((e) => {
              const t = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(".quick-order-list-container").parentNode;
              this.innerHTML = t.innerHTML;
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }).bind(this),
    ).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`),
    );
  }
}
customElements.define("bulk-modal", BulkModal);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("button");
    e &&
      e.addEventListener("click", (t) => {
        const s = document.querySelector(this.getAttribute("data-modal")),
          i = t.target.dataset.mediaId;
        if (s) {
          const t = s.querySelector("dbtfy-slider-component");
          if ((t && (s.style.visibility = "hidden"), s.show(e), t)) {
            const e = this.getMediaPositionById(i, s);
            (t.goToSlide(e), (s.style.visibility = "visible"));
          }
        }
      });
  }
  getMediaPositionById(e, t) {
    if (!t.querySelector("#Slide-" + e)) return;
    const s = t.querySelectorAll('[id^="Slide-"]');
    for (let t = 0; t < s.length; t++) if (s[t].id === "Slide-" + e) return t + 1;
    return -1;
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      const t = document.createElement("div");
      (t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
        this.setAttribute("loaded", !0));
      const s = this.appendChild(t.querySelector("video, model-viewer, iframe"));
      (e && s.focus(),
        "VIDEO" == s.nodeName && s.getAttribute("autoplay"),
        "false" == this.dataset.controls && "false" == this.dataset.autoplay && s.play());
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(".slider-counter--current")),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    this.initPages();
    (new ResizeObserver((e) => this.initPages()).observe(this.slider),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this)));
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
        )),
        this.slidesPerPage < 1 && (this.slidesPerPage = 1),
        (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update()));
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages());
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    const e = this.currentPage;
    ((this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != e &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(e, t = 0) {
    const s = this.slider.clientWidth + this.slider.scrollLeft - t;
    return e.offsetLeft + e.clientWidth <= s && e.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = e.currentTarget.dataset.step || 1;
    ((this.slideScrollPosition =
      "next" === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderItemOffset
        : this.slider.scrollLeft - t * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition));
  }
  setSlidePosition(e) {
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.announcementBarSlider = this.querySelector(".announcement-bar-slider")),
        (this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((e) =>
          e.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
        this.setSlideVisibility(),
        this.announcementBarSlider &&
          ((this.announcementBarArrowButtonWasClicked = !1),
          (this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")),
          this.reducedMotion.addEventListener("change", () => {
            "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay();
          }),
          [this.prevButton, this.nextButton].forEach((e) => {
            e.addEventListener(
              "click",
              () => {
                this.announcementBarArrowButtonWasClicked = !0;
              },
              { once: !0 },
            );
          })),
        "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay()));
  }
  setAutoPlay() {
    ((this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.querySelector(".slideshow__autoplay")
        ? ((this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
          this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)),
          (this.autoplayButtonIsSetToPlay = !0),
          this.play())
        : this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
          ? this.pause()
          : this.play());
  }
  onButtonClick(e) {
    (super.onButtonClick(e), (this.wasClicked = !0));
    const t = 1 === this.currentPage,
      s = this.currentPage === this.sliderItemsToShow.length;
    t || s
      ? (t && "previous" === e.currentTarget.name
          ? (this.slideScrollPosition =
              this.slider.scrollLeft +
              this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
          : s && "next" === e.currentTarget.name && (this.slideScrollPosition = 0),
        this.setSlidePosition(this.slideScrollPosition),
        this.applyAnimationToAnnouncementBar(e.currentTarget.name))
      : this.applyAnimationToAnnouncementBar(e.currentTarget.name);
  }
  setSlidePosition(e) {
    (this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
      (this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({ left: e });
      }, this.announcerBarAnimationDelay)));
  }
  update() {
    (super.update(),
      (this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((e) => {
          (e.classList.remove("slider-counter__link--active"), e.removeAttribute("aria-current"));
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active",
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0)));
  }
  autoPlayToggle() {
    (this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay));
  }
  focusOutHandling(e) {
    if (this.sliderAutoplayButton) {
      const t =
        e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
      if (!this.autoplayButtonIsSetToPlay || t) return;
      this.play();
    } else this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || this.play();
  }
  focusInHandling(e) {
    if (this.sliderAutoplayButton) {
      (e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)) &&
      this.autoplayButtonIsSetToPlay
        ? this.play()
        : this.autoplayButtonIsSetToPlay && this.pause();
    } else this.announcementBarSlider.contains(e.target) && this.pause();
  }
  play() {
    (this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)));
  }
  pause() {
    (this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay));
  }
  togglePlayButtonState(e) {
    e
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow,
        ))
      : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow,
        ));
  }
  autoRotateSlides() {
    const e =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;
    (this.setSlidePosition(e), this.applyAnimationToAnnouncementBar());
  }
  setSlideVisibility(e) {
    (this.sliderItemsToShow.forEach((e, t) => {
      const s = e.querySelectorAll("a");
      t === this.currentPage - 1
        ? (s.length &&
            s.forEach((e) => {
              e.removeAttribute("tabindex");
            }),
          e.setAttribute("aria-hidden", "false"),
          e.removeAttribute("tabindex"))
        : (s.length &&
            s.forEach((e) => {
              e.setAttribute("tabindex", "-1");
            }),
          e.setAttribute("aria-hidden", "true"),
          e.setAttribute("tabindex", "-1"));
    }),
      (this.wasClicked = !1));
  }
  applyAnimationToAnnouncementBar(e = "next") {
    if (!this.announcementBarSlider) return;
    const t = this.sliderItems.length,
      s = "next" === e ? 1 : -1,
      i = this.currentPage - 1;
    let n = (i + s) % t;
    n = -1 === n ? t - 1 : n;
    const r = this.sliderItems[n],
      o = this.sliderItems[i],
      a = "announcement-bar-slider--fade-in",
      l = "announcement-bar-slider--fade-out",
      d = ("next" === e && !(i === t - 1)) || ("previous" === e && 0 === i) ? "next" : "previous";
    (o.classList.add(`${l}-${d}`),
      r.classList.add(`${a}-${d}`),
      setTimeout(() => {
        (o.classList.remove(`${l}-${d}`), r.classList.remove(`${a}-${d}`));
      }, 2 * this.announcerBarAnimationDelay));
  }
  linkToSlide(e) {
    e.preventDefault();
    const t =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: t });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (document.body.classList.contains("dbtfy_linked_options") &&
      ((this.backInStock = document.querySelector(".dbtfy-back-in-stock:not(.debutify-handler)")),
      this.backInStock &&
        ((this.optionList = this.querySelectorAll("option").length),
        (this.disabledOptionList = this.querySelectorAll("option.dropdown_disabled").length),
        this.optionList == this.disabledOptionList
          ? (this.backInStock.style.display = "block")
          : (this.backInStock.style.display = "none"),
        (this.fieldset = this.querySelectorAll("fieldset input.disabled").length),
        (this.disabled = this.querySelectorAll("fieldset input").length),
        this.fieldset == this.disabled
          ? (this.backInStock.style.display = "block")
          : (this.backInStock.style.display = "none")),
      this.querySelectorAll("select").forEach((e) => {
        ((this.optionList = e.querySelectorAll("option")),
          (this.disabledOptionList = e.querySelectorAll("option.dropdown_disabled")),
          this.optionList.length == this.disabledOptionList.length
            ? e.closest(".select").remove()
            : e.querySelectorAll("option.dropdown_disabled").forEach((e) => e.remove()));
      }),
      this.querySelectorAll("fieldset").forEach((e) => {
        ((this.fieldsetList = e.querySelectorAll("input")),
          (this.disabledFieldsetList = e.querySelectorAll("input.disabled")));
        const t = e.querySelector("input.disabled:checked");
        if (
          (e.querySelectorAll("input.disabled").forEach((t) => {
            const s = e.querySelector(`label[for="${t.id}"]`);
            (s && s.remove(), t.remove());
          }),
          t)
        ) {
          const t = e.querySelector("input");
          if (t) {
            ((t.checked = !0), t.dispatchEvent(new Event("change")));
            const e = "custom";
            publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: { event: e, target: t, selectedOptionValues: this.selectedOptionValues },
            });
          }
        }
      })),
      this.dispatchEvent(new CustomEvent("variant-selects:loaded", { bubbles: !0 })),
      this.addEventListener("change", (e) => {
        const t = this.getInputForEventTarget(e.target);
        (this.updateSelectionMetadata(e),
          publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: { event: e, target: t, selectedOptionValues: this.selectedOptionValues },
          }));
      }),
      this.selectedOptionValues.length !==
        this.querySelectorAll("select option[selected], fieldset input:checked").length &&
        this.dispatchEvent(new Event("change", { bubbles: !0 })),
      this.checkSwatch(),
      setTimeout(() => {
        this.checkThumbnailCarousel();
      }, 500));
  }
  checkThumbnailCarousel() {
    const e = this.closest(".product--thumbnail_slider");
    if (!e) return;
    const t = e.querySelectorAll(
        "#thumbnail-carousel.hide_variants_thumbnail .thumbnail-list_item--carousel",
      ),
      s = e.querySelectorAll("#thumbnail-carousel.hide_variants_thumbnail .splide__arrows");
    t.length > 4
      ? s.forEach((e) => e.classList.remove("hidden"))
      : s.forEach((e) => {
          e && e.classList.add("hidden");
        });
  }
  updateSelectionMetadata({ target: e }) {
    const { value: t, tagName: s } = e;
    if ("SELECT" === s && e.selectedOptions.length) {
      (Array.from(e.options)
        .find((e) => e.getAttribute("selected"))
        .removeAttribute("selected"),
        e.selectedOptions[0].setAttribute("selected", "selected"));
      const t = e.value
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w\-]+/g, "")
          .replace(/--+/g, "-"),
        s = e.selectedOptions[0].dataset.optionSwatchValue,
        i = e.closest(".product-form__input").querySelector("[data-selected-value] > .swatch");
      if (!i) return;
      (s
        ? (i.style.setProperty("--swatch--background", s),
          i.classList.remove("swatch--unavailable"),
          i.closest("[data-selected-value]").classList.remove("empty-swatch"))
        : (i.style.setProperty("--swatch--background", "unset"),
          i.classList.add("swatch--unavailable"),
          i.closest("[data-selected-value]").classList.add("empty-swatch")),
        (i.dataset.selectedValue = t),
        i.style.setProperty(
          "--swatch-focal-point",
          e.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
        ));
    } else if ("INPUT" === s && "radio" === e.type) {
      const s = e.closest(".product-form__input").querySelector("[data-selected-value]");
      s && (s.innerHTML = t);
    }
  }
  getInputForEventTarget(e) {
    return "SELECT" === e.tagName ? e.selectedOptions[0] : e;
  }
  get selectedOptionValues() {
    const e = [];
    return (
      this.querySelectorAll("select").forEach((t) => {
        const s = t.selectedOptions[0] || t.options[0];
        s && s.dataset.optionValueId && e.push(s.dataset.optionValueId);
      }),
      this.querySelectorAll("fieldset input:checked").forEach((t) => {
        t && t.dataset.optionValueId && e.push(t.dataset.optionValueId);
      }),
      e
    );
  }
  checkSwatch() {
    const e = Array.from(document.querySelectorAll("[data-color-swatch-json]")).flatMap((e) => {
      const t = JSON.parse(e.innerHTML);
      return t[0]?.toLowerCase();
    });
    this.querySelectorAll('[data-swatch-count="0"]').forEach((t) => {
      t.querySelectorAll(".swatch-input__input").forEach((t) => {
        if (!t.nextElementSibling.querySelector(".swatch--unavailable")) return;
        let s = t.value.trim();
        (Debutify.settings.ignore_swatch_case_varinat_picker && (s = s.toLowerCase()),
          e.includes(s) || t.classList.add("empty-swatch"));
      });
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class ProductRecommendations extends HTMLElement {
  observer = void 0;
  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(e) {
    (this.observer?.unobserve(this),
      (this.observer = new IntersectionObserver(
        (t, s) => {
          t[0].isIntersecting && (s.unobserve(this), this.loadRecommendations(e));
        },
        { rootMargin: "0px 0px 400px 0px" },
      )),
      this.observer.observe(this));
  }
  loadRecommendations(e) {
    fetch(`${this.dataset.url}&product_id=${e}&section_id=${this.dataset.sectionId}`)
      .then((e) => e.text())
      .then((e) => {
        const t = document.createElement("div");
        t.innerHTML = e;
        const s = t.querySelector("product-recommendations");
        (s?.innerHTML.trim().length && (this.innerHTML = s.innerHTML),
          !this.querySelector("dbtfy-slider-component") &&
            this.classList.contains("complementary-products") &&
            this.remove(),
          t.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded"));
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class AccountIcon extends HTMLElement {
  constructor() {
    (super(), (this.icon = this.querySelector(".icon")));
  }
  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }
  handleStorefrontSignInCompleted(e) {
    e?.detail?.avatar && this.icon?.replaceWith(e.detail.avatar.cloneNode());
  }
}
customElements.get("shopify-account") || customElements.define("shopify-account", AccountIcon);
class BulkAdd extends HTMLElement {
  constructor() {
    (super(), (this.queue = []), (this.requestStarted = !1), (this.ids = []));
  }
  startQueue(e, t) {
    this.queue.push({ id: e, quantity: t });
    const s = setInterval(() => {
      this.queue.length > 0
        ? this.requestStarted || this.sendRequest(this.queue)
        : clearInterval(s);
    }, 250);
  }
  sendRequest(e) {
    this.requestStarted = !0;
    const t = {};
    (e.forEach((e) => {
      t[parseInt(e.id)] = e.quantity;
    }),
      (this.queue = this.queue.filter((t) => !e.includes(t))));
    (this.closest("quick-order-list") || this.closest("quick-add-bulk")).updateMultipleQty(t);
  }
  resetQuantityInput(e) {
    const t = this.querySelector(`#Quantity-${e}`);
    ((t.value = t.getAttribute("value")), (this.isEnterPressed = !1));
  }
  setValidity(e, t, s) {
    (e.target.setCustomValidity(s),
      e.target.reportValidity(),
      this.resetQuantityInput(t),
      e.target.select());
  }
  validateQuantity(e) {
    const t = parseInt(e.target.value),
      s = e.target.dataset.index;
    t < e.target.dataset.min
      ? this.setValidity(
          e,
          s,
          window.quickOrderListStrings.min_error.replace("[min]", e.target.dataset.min),
        )
      : t > parseInt(e.target.max)
        ? this.setValidity(
            e,
            s,
            window.quickOrderListStrings.max_error.replace("[max]", e.target.max),
          )
        : t % parseInt(e.target.step) != 0
          ? this.setValidity(
              e,
              s,
              window.quickOrderListStrings.step_error.replace("[step]", e.target.step),
            )
          : (e.target.setCustomValidity(""), e.target.reportValidity(), this.startQueue(s, t));
  }
  getSectionsUrl() {
    return window.pageNumber
      ? `${window.location.pathname}?page=${window.pageNumber}`
      : `${window.location.pathname}`;
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }
}
function checkoutButtonHandler() {
  const e = document.querySelectorAll(".cart__checkout-button");
  if (e.length > 0) {
    const t = Object.values(Debutify.checkout).every((e) => !0 === e);
    e.forEach((e) => {
      e.disabled = !t;
    });
  }
}
function getPreviousElementSiblings(e, t) {
  let s = e?.previousElementSibling;
  if (!s) return null;
  for (; s && (!s.id || !s.id.startsWith(t));) s = s.previousElementSibling;
  return s || null;
}
(customElements.get("bulk-add") || customElements.define("bulk-add", BulkAdd),
  customElements.get("mobile-slider") ||
    customElements.define(
      "mobile-slider",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.mobileCol = this.dataset.mobileCol),
            (this.mobileSlider = this.dataset.mobileSlider),
            (this.selectorSlider = this.querySelector(this.dataset.selectorMain)),
            (this.colLength = this.querySelectorAll(this.dataset.selectorLength).length),
            (this.sliderButtons = this.querySelector(this.dataset.selectorArrow)),
            (this.MobileSwiperToggle = this.querySelector(this.dataset.selectorMobileSwiperToggle)),
            this.colLength && this.mobileSlider && this.mobileCol
              ? this.init()
              : this.sliderButtons?.remove());
        }
        init() {
          (this.MobileSwiperToggle && (this.MobileSwiperToggle.style.display = "none"),
            window.innerWidth < 989 &&
              (this.colLength > this.mobileCol && "true" === this.mobileSlider
                ? (this.selectorSlider.classList.add("slider", "slider--tablet", "grid--peek"),
                  this.MobileSwiperToggle && (this.MobileSwiperToggle.style.display = "none"))
                : this.sliderButtons &&
                  (this.sliderButtons.remove(),
                  this.MobileSwiperToggle && (this.MobileSwiperToggle.style.display = "block"))));
        }
      },
    ),
  customElements.get("collpasible-content") ||
    customElements.define(
      "collpasible-content",
      class extends HTMLElement {
        constructor() {
          (super(), (this.firstOpen = this.dataset.firstOpen), this.init());
        }
        init() {
          "true" == this.firstOpen &&
            this.querySelector(".accordion details").setAttribute("open", "");
        }
      },
    ),
  customElements.get("product-card-slider") ||
    customElements.define(
      "product-card-slider",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.selector = this.dataset.selector),
            (this.showSecondaryImage = String(
              "true" === this.dataset.showSecondaryImage && window.screen.width > 768,
            )),
            (this.currentImage = 0),
            (this.size = +this.dataset.size),
            (this.prevButton = this.querySelector(`button[name="previous-${this.selector}"]`)),
            (this.nextButton = this.querySelector(`button[name="next-${this.selector}"]`)),
            (this.images = this.querySelectorAll(`[data-product-id="${this.selector}"]`)),
            this.prevButton && (this.prevButton.disabled = !0),
            this.size > 1 &&
              this.nextButton &&
              this.prevButton &&
              (this.prevButton.classList.remove("hidden"),
              this.nextButton.classList.remove("hidden")),
            "true" === this.showSecondaryImage && this.size > 1
              ? (this.images[1]?.classList.remove("hidden"),
                this.querySelector(".media--transparent")?.classList.add("media--hover-effect"))
              : (this.images[1]?.classList.add("hidden"),
                this.querySelector(".media--transparent")?.classList.remove("media--hover-effect")),
            window.addEventListener("resize", () => {
              ((this.showSecondaryImage = String(
                "true" === this.dataset.showSecondaryImage && window.screen.width > 768,
              )),
                "true" === this.showSecondaryImage && this.size > 1
                  ? (this.images[1]?.classList.remove("hidden"),
                    this.querySelector(".media--transparent")?.classList.add("media--hover-effect"))
                  : (this.images[1]?.classList.add("hidden"),
                    this.querySelector(".media--transparent")?.classList.remove(
                      "media--hover-effect",
                    )));
            }));
        }
        revealImageWithoutHidden(e) {
          this.images[e] &&
            (this.images[e].classList.remove("hidden"),
            "VIDEO" === this.images[e].tagName && this.images[e].play());
        }
        revealImage(e) {
          this.images.forEach((t, s) => {
            (("true" === this.showSecondaryImage && 0 == s) ||
              (s === e
                ? (t.classList.remove("hidden"), "VIDEO" === t.tagName && t.play())
                : t.classList.add("hidden")),
              0 === e &&
                "true" === this.showSecondaryImage &&
                (this.images[1]?.classList.remove("hidden"),
                "VIDEO" === this.images[1].tagName && this.images[1].play()));
          });
        }
        connectedCallback() {
          (this.revealImageWithoutHidden(this.currentImage),
            "true" === this.showSecondaryImage &&
              this.images.length > 1 &&
              ("VIDEO" === this.images[0].tagName && this.images[0].pause(),
              this.revealImageWithoutHidden(this.currentImage + 1)),
            this.initializeThumbnails(),
            this.prevButton?.addEventListener("click", () => {
              ((this.currentImage -= 1),
                this.revealImage(this.currentImage),
                this.updateActiveThumbnail(!0),
                0 === this.currentImage
                  ? (this.prevButton.disabled = !0)
                  : (this.nextButton.disabled = !1));
            }),
            this.nextButton?.addEventListener("click", () => {
              ((this.currentImage += 1),
                this.revealImage(this.currentImage),
                this.updateActiveThumbnail(!0),
                this.currentImage === this.images.length - 1
                  ? (this.nextButton.disabled = !0)
                  : (this.prevButton.disabled = !1));
            }));
        }
        initializeThumbnails() {
          const e = this.closest(".card")?.querySelector(".card__thumbnails .splide"),
            t = this.closest(".card")?.querySelectorAll(".card__thumbnail");
          if (e) {
            const s = () => {
              "undefined" == typeof Splide ||
                this.thumbnailSlider ||
                ((this.thumbnailSlider = new Splide(e, {
                  autoWidth: !0,
                  gap: 6,
                  focus: t.length > 4 ? "center" : 0,
                  pagination: !1,
                  arrows: !1,
                  drag: !0,
                  trimSpace: !0,
                })),
                this.thumbnailSlider.mount());
            };
            "undefined" != typeof Splide ? s() : document.addEventListener("DOMContentLoaded", s);
          }
          t &&
            0 !== t.length &&
            (t.forEach((e, t) => {
              e.addEventListener("click", () => {
                ((this.currentImage = t),
                  this.revealImage(this.currentImage),
                  this.updateActiveThumbnail(!0),
                  this.prevButton && (this.prevButton.disabled = 0 === this.currentImage),
                  this.nextButton &&
                    (this.nextButton.disabled = this.currentImage === this.images.length - 1));
              });
            }),
            this.updateActiveThumbnail(!1));
        }
        updateActiveThumbnail(e = !1) {
          const t = this.closest(".card")?.querySelectorAll(".card__thumbnail");
          t &&
            0 !== t.length &&
            t.forEach((t, s) => {
              if (s === this.currentImage) {
                if ((t.setAttribute("aria-current", "true"), e))
                  if (this.thumbnailSlider) this.thumbnailSlider.go(s);
                  else {
                    const e = t.closest(".card__thumbnail-list");
                    if (e) {
                      const s = e.getBoundingClientRect(),
                        i = t.getBoundingClientRect(),
                        n = i.left - s.left + e.scrollLeft - s.width / 2 + i.width / 2;
                      e.scrollTo({ left: n, behavior: "smooth" });
                    }
                  }
              } else t.removeAttribute("aria-current");
            });
        }
      },
    ));
let maxHeaderHeight = 0;
function adjustHeaderBasedOnAnnaHeadergroup() {
  if (0 == Debutify.settings.dbtfy_sticky_header) return;
  let e = document.querySelector(".dbtfy-announcement-bar");
  e?.offsetHeight || (e = document.querySelector(".dbtfy-announcement-bar .announcement-contents"));
  const t = document.querySelector(".dbtfy-header"),
    s = t?.offsetHeight | t?.querySelector("sticky-header")?.offsetHeight;
  maxHeaderHeight < s && (maxHeaderHeight = s);
  const i = Debutify.widgets.announcement?.sticky_bar;
  (i || ("undefined" != typeof announcementLoadAfterHeader && announcementLoadAfterHeader)) &&
    (maxHeaderHeight = s + e.offsetHeight);
  let n = 0,
    r = getPreviousElementSiblings(t, "shopify-section"),
    o = 0,
    a = getPreviousElementSiblings(e, "shopify-section");
  for (; r;) ((n += r.offsetHeight), (r = getPreviousElementSiblings(r, "shopify-section")));
  for (; a;)
    (a.offsetHeight
      ? (o += a.offsetHeight)
      : a.classList.contains("section-header") &&
        (o += a.querySelector("sticky-header")?.offsetHeight),
      (a = getPreviousElementSiblings(a, "shopify-section")));
  (Debutify.widgets.header?.sticky_header_type &&
  "none" != Debutify.widgets.header?.sticky_header_type
    ? (((Debutify.widgets.header.header_transparent &&
        document.body.classList.contains("template-index")) ||
        (Debutify.widgets.header.collection_header_transparent &&
          document.body.classList.contains("template-collection"))) &&
        (t.classList.add("header--transparent"),
        (document.querySelector("main").style.marginTop = `-${maxHeaderHeight}px`)),
      i
        ? t.style.setProperty("--height-header", `${n}px`)
        : t.style.setProperty("--height-header", "0px"))
    : t?.style.setProperty("--height-header", "0px"),
    i
      ? e?.style.setProperty("--height--annauncement-bar", `${o}px`)
      : e?.style.setProperty("--height--annauncement-bar", "0px"),
    document.body.classList.add("header-loaded"));
  const l = Debutify.widgets.header?.sticky_header_type;
  "reduce-logo-size" == l || "always" == l
    ? document.body.style.setProperty("--sticky-header-height", `${maxHeaderHeight}px`)
    : document.body.style.setProperty("--sticky-header-height", "0px");
}
if (
  (0 != Debutify.settings.dbtfy_sticky_header
    ? (window.addEventListener("load", adjustHeaderBasedOnAnnaHeadergroup),
      window.addEventListener("resize", adjustHeaderBasedOnAnnaHeadergroup),
      window.addEventListener("scroll", adjustHeaderBasedOnAnnaHeadergroup))
    : (document.body.style.setProperty("--sticky-header-height", "0px"),
      document.body.classList.add("header-loaded")),
  customElements.get("card-product-variant-selects") ||
    customElements.define(
      "card-product-variant-selects",
      class extends HTMLElement {
        constructor() {
          (super(),
            this.querySelectorAll(".swatch-input__input").forEach((e) => {
              e.addEventListener("click", (t) => {
                const s = e.dataset.mediaId,
                  i = e.dataset.mediaImage;
                if (!s || !i) return;
                const n = t.target.closest(".card").querySelector("product-card-slider"),
                  r = n.dataset.showCarousel,
                  o = n.dataset.showThumbnailCarousel,
                  a = n.dataset.enableSlider,
                  l = n.dataset.showSecondaryImage,
                  d = e.closest(".card-wrapper").querySelector(".card__media"),
                  c = d.querySelector(`img[media-id="${s}"]`);
                if ("true" === r || "true" === o || "true" === a) {
                  const e = Array.from(n.images).indexOf(c);
                  -1 !== e && ((n.currentImage = e), n.revealImage(e), n.updateActiveThumbnail(!0));
                } else if ("true" === l) {
                  const e = d.querySelectorAll("img")[1];
                  e && ((e.srcset = i), (e.src = i));
                } else {
                  const e = d.querySelector("img");
                  e && ((e.srcset = i), (e.src = i));
                }
              });
            }));
        }
      },
    ),
  customElements.get("add-to-cart-product") ||
    customElements.define(
      "add-to-cart-product",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.id = this.dataset.productId),
            this.querySelector(".button_add_to_cart")?.addEventListener("click", (e) => {
              (e.preventDefault(), Debutify.ajaxAddToCart({ id: Number(this.id), quantity: 1 }));
            }));
        }
      },
    ),
  !window.DbtfyDiscountCode)
) {
  window.DbtfyDiscountCodeInitialized = !1;
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      !window.DbtfyDiscountCodeInitialized &&
        Debutify.settings.apply_auto_discount &&
        (this.initDiscount(),
        subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this)));
    }
    initDiscount() {
      ((window.DbtfyDiscountCodeInitialized = !0),
        (this.unsubscribeDiscount = subscribe(PUB_SUB_EVENTS.applyDiscount, (e) => {
          const t = e.discountCode;
          t &&
            fetch(`/discount/${t}`, {
              method: "GET",
              headers: { "X-Requested-With": "XMLHttpRequest" },
            })
              .then((e) => {
                e.ok || console.error("Failed to apply discount: " + e.statusText);
              })
              .catch((e) => {
                console.error("Error applying discount:", e);
              })
              .finally(() => {
                "page" === Debutify.settings.cart_type
                  ? window.location.reload()
                  : "drawer" === Debutify.settings.cart_type &&
                    fetch(`${routes.cart_url}?section_id=cart-drawer`)
                      .then((e) => e.text())
                      .then((e) => {
                        const t = new DOMParser()
                            .parseFromString(e, "text/html")
                            .querySelector("#shopify-section-cart-drawer #CartDrawer"),
                          s = document.querySelector("#shopify-section-cart-drawer #CartDrawer");
                        s && t && s.replaceWith(t);
                      })
                      .catch((e) => {
                        console.error(e);
                      });
              });
        })));
    }
    setTotalQuantity() {
      const e = this.addedProductID,
        t = this.cartItems;
      let s = 0;
      (t.forEach((t) => {
        t.product_id == e && (s += t.quantity);
      }),
        (this.totalAddedQuantity = s));
    }
    async handleCartUpdate(e) {
      try {
        ((this.cartItems = e.cartData.items),
          0 != e.cartData.items_added.length
            ? ((this.addedProductID = e.cartData.items_added[0].product_id),
              (this.addedProductHandle = e.cartData.items_added[0].url.split("?")[0]))
            : ((this.addedProductID = e.cartData.items_removed[0].product_id),
              (this.addedProductHandle = e.cartData.items_removed[0].url.split("?")[0])),
          this.setTotalQuantity());
        const t = Debutify.widgets["qty-breaks"]?.product_break,
          s = Debutify.widgets["qty-breaks"]?.cart_break;
        ((this.cartTotalPrice = e.cartData.original_total_price),
          (this.cartItemCount = e.cartData.item_count),
          (this.highestDiscountCode = null),
          (this.highestDiscountAmount = 0),
          (this.highestDiscountType = "%"));
        for (let e = 0; e < s.length; e++)
          for (let t = 1; t <= 10; t++) {
            const i = s[e][`cart_break_range_${t}`],
              n = s[e][`cart_break_discount_code_${t}`],
              r = s[e][`cart_break_discount_type_${t}`],
              o = s[e][`cart_break_discount_amount_${t}`];
            if (this.cartItemCount >= i && o) {
              const e = parseFloat(o);
              if (!isNaN(e) && e > 0) {
                let t = 0;
                ((t = "%" === r ? (e / 100) * this.cartTotalPrice : e),
                  t > this.highestDiscountAmount &&
                    ((this.highestDiscountAmount = t),
                    (this.highestDiscountCode = n || "(no code)"),
                    (this.highestDiscountType = r)));
              }
            }
          }
        (await this.filterVisibility(t),
          this.filterValidatedQuantity(),
          publish(PUB_SUB_EVENTS.applyDiscount, { discountCode: this.highestDiscountCode }));
      } catch (e) {}
    }
    async filterVisibility(e) {
      try {
        let t = await Debutify.fetchProductMarkup(
          `${this.addedProductHandle}?view=internal-full-product-details`,
        );
        if (t) {
          const s = new DOMParser(),
            i = s.parseFromString(t, "text/html").querySelector("body").innerHTML,
            n = JSON.parse(i),
            r = n.product,
            o = n.collections.map((e) => e.handle),
            a = e.filter((e) => {
              switch (e.product_break_visibility) {
                case "collection":
                  return o.includes(e.product_break_collection);
                case "type":
                  return e.product_break_types.toLowerCase().includes(r.type.toLowerCase());
                case "tag":
                  return r.tags.some((t) =>
                    e.product_break_tags.toLowerCase().includes(t.toLowerCase()),
                  );
                case "product":
                  return e.product_break_product === r.handle;
                case "all":
                  return !0;
                default:
                  return !1;
              }
            });
          this.filteredItems = a;
        }
      } catch (e) {
        return (console.error("Error: " + e), null);
      }
    }
    filterValidatedQuantity() {
      if (!(this.filteredItems && this.filteredItems.length > 0)) return null;
      for (const e of this.filteredItems)
        for (const t of e.breaks)
          if (this.totalAddedQuantity >= t.product_break_range) {
            const e = parseFloat(t.product_break_discount_amount);
            if (!isNaN(e) && e > 0) {
              const s = "%" === t.product_break_discount_type ? (e / 100) * this.cartTotalPrice : e;
              s > this.highestDiscountAmount &&
                ((this.highestDiscountAmount = s),
                (this.highestDiscountCode = t.product_break_discount_code || "(no code)"),
                (this.highestDiscountType = t.product_break_discount_type));
            }
          }
    }
  }
  window.DbtfyDiscountCode = e;
}
